import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const APPLICANT_ATTACHMENTS_QUERY_KEY = ["applicant-attachments"];
export const VIEW_APPLATTACHMENTS_QUERY_KEY = ["view-applicant-attachments"];

export const applicantAttachmentsService = {
  viewByApplication: async (application_no: string) => {
    const response = await api.get(
      `api/view-applicant-attachments/${application_no}/appl-no`,
    );
    return response.data.data;
  },
  uploadAttachment: async (payload: FormData) => {
    return api.post(
      `api/applicant-attachments`,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },
  downloadAttachment: async (file_path: string) => {
     return api.get(
      `api/applicant-attachments/download/${file_path}`,
      {
        responseType: "blob",
      }
    );
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/applicant-attachments/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  updateAttachment: async (
    id: number,
    category_id: number,
  ) => {
    const response = await api.patch(
      `api/applicant-attachments/${id}`,
      {
        category_id,
      }
    );
    return response.data;
  },

};
